import { useTranslation } from 'react-i18next'

import { SEARCH_RESULTS_PROVIDERS_ENTITY } from '../../../constants/entity'
import { ROUTE_PATH_LIST } from '../../../constants/route'
import { ProviderTableLayout, useProviderTablePage } from '../../Provider'
import { useSearchResultsTableOptions } from '../SearchResults.hooks'
import { getSearchResultsBreadcrumbs } from '../SearchResults.utils'
import { SearchResultsPage } from '../SearchResultsPage'

import { updateSearchResultsProvidersTableConfig } from './SearchResultsProviders.api'
import {
  QA_NAME_SEARCH_RESULTS_PROVIDERS_TABLE,
  SEARCH_RESULTS_PROVIDERS_CONFIG_API,
  SEARCH_RESULTS_PROVIDERS_LIST_API,
} from './SearchResultsProviders.constants'

import ProvidersIcon from '../../../icons/providers.svg'

function SearchResultsProviders() {
  const { t } = useTranslation()

  const { asyncTableOptions, extraSelectionResetDeps, searchQuery } =
    useSearchResultsTableOptions({
      asyncTableOptions: {
        listApi: SEARCH_RESULTS_PROVIDERS_LIST_API,
        tableConfigApi: SEARCH_RESULTS_PROVIDERS_CONFIG_API,
      },
    })

  const tablePage = useProviderTablePage({
    asyncTableOptions,
    entity: SEARCH_RESULTS_PROVIDERS_ENTITY,
    extraSelectionResetDeps,
    pageTitle: t('SearchResults.ProvidersBrowserTabTitleKey'),
    onApplyTableConfig: updateSearchResultsProvidersTableConfig,
  })

  const breadcrumbs = getSearchResultsBreadcrumbs({
    leadingBreadcrumbs: [
      {
        id: 'providers',
        title: t('BrowserTab.ProvidersPageTitleKey'),
        to: `/${ROUTE_PATH_LIST.providers}/`,
      },
    ],
    searchQuery,
    t,
  })

  return (
    <SearchResultsPage
      EntityIcon={ProvidersIcon}
      TableLayout={ProviderTableLayout}
      breadcrumbs={breadcrumbs}
      emptyText={t('ProviderTable.NoDataKey')}
      qaName={QA_NAME_SEARCH_RESULTS_PROVIDERS_TABLE}
      tablePage={tablePage}
    />
  )
}

export default SearchResultsProviders
